// class GradientHeroSection {
//   constructor(section) {
//     this.el = section;
//     this.prev = this.getPrevSection(section);
//     if (!this.prev) return;

//     this.start = { x: -530, y: 250, scale: 0.2 };
//     this.end = { x: 0, y: 0, scale: 1 };

//     this.el.style.transform = `translateX(0) translateY(0) scale(${this.start.scale})`;
//     this.el.style.transformOrigin = '50px bottom';
//     this.el.style.willChange = 'transform';

//     window.addEventListener('scroll', () => this.onScroll());
//   }

//   getPrevSection(el) {
//     let prev = el.previousElementSibling;
//     while (prev && !prev.classList.contains('shopify-section')) prev = prev.previousElementSibling;
//     return prev;
//   }

//   onScroll() {
//     const rect = this.prev.getBoundingClientRect();
//     const triggerHeight = rect.height * 0.8;
//     const p = Math.min(Math.max(-rect.top, 0), triggerHeight) / triggerHeight;
//     const s = this.start.scale + (this.end.scale - this.start.scale) * p;
//     this.el.style.transform = `translateX(0) translateY(0) scale(${s})`;
//   }
// }


//   document.querySelectorAll('.shopify-section').forEach((section) => {
//   if (section.querySelector('.gradient-hero-section')) {
//     new GradientHeroSection(section);
//   }
// });

class GradientHeroSection {
  constructor(section) {
    this.el = section;
    this.innerSection =  this.el.querySelector('.gradient-hero-section');
    this.prev = this.getPrevSection(section);
    if (!this.prev) return;

    this.startScale = 0.2;
    this.endScale = 1;
    this.startY = 250;

    this.el.style.transform = `translateX(0) translateY(250px)  scale(${this.startScale})`;
    this.el.style.transformOrigin = '50px bottom';
    this.el.style.willChange = 'transform';
    // this.innerSection.style.willChange = ' opacity';
    // this.innerSection.style.opacity = '0';
    // this.innerSection.style.visibility = 'hidden';
    this.onScroll();
    window.addEventListener('scroll', () => this.onScroll());
    window.addEventListener('resize', () => this.onScroll());
  }

  getPrevSection(el) {
    let prev = el.previousElementSibling;
    while (prev && !prev.classList.contains('shopify-section')) {
      prev = prev.previousElementSibling;
    }
    return prev;
  }

  // onScroll() {
  //   const rect = this.prev.getBoundingClientRect();
  //   const viewportHeight = window.innerHeight;
  //   const midpoint = viewportHeight / 2;
  //   console.log("bottom",rect.bottom);
  //   // if (rect.top <= midpoint) { 
  //   if (rect.top <= 0) { 
  //     this.innerSection.style.opacity = '1';
  //     this.innerSection.style.visibility = 'visible';
  //   } else {
  //     this.innerSection.style.opacity = '0';
  //     this.innerSection.style.visibility = 'hidden';
  //   }

  //   const triggerHeight = rect.height * .3;
  //   // const p = Math.min(Math.max(-rect.bottom , 0), triggerHeight) / triggerHeight;
  //   const p = Math.min(Math.max(-rect.bottom , 600), triggerHeight) / triggerHeight;
  //   const scale = this.startScale + (this.endScale - this.startScale) * p;

  //   this.el.style.transform = `translateX(0) translateY(0)  scale(${scale})`;
  // }
  onScroll() {
  const rect = this.prev.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const triggerHeight = rect.height * .3;
  const scrollProgress = Math.min(Math.max(viewportHeight - rect.bottom, 0), triggerHeight) / triggerHeight;
  const translateY = this.startY * (1 - scrollProgress);
  const scale = this.startScale + (this.endScale - this.startScale) * scrollProgress;

  if (rect.top <= 100 && rect.top >= -1000) {
    this.innerSection.style.opacity = '1';
    this.innerSection.style.visibility = 'visible';
    this.el.style.transform = `translateX(0) translateY(0)  scale(${scale})`;
    this.el.style.transition = `all .3s linear`;
  }
  else if (rect.top <= 100) {
    this.innerSection.style.opacity = '1';
    this.innerSection.style.visibility = 'visible';
    this.el.style.transform = `translateX(0) translateY(0)  scale(${scale})`;
    this.el.style.transition = `translate .3s linear`;
  } else {
    this.el.style.transition = `all .3s linear`;
    this.el.style.transform = `translateX(0) translateY(200px)  scale(0.2)`;
    // this.innerSection.style.opacity = '0';
    // this.innerSection.style.visibility = 'hidden';
  }

  this.el.style.transform = `translateX(0) translateY(${translateY}) scale(${scale})`;
}

}

// Initialize
document.querySelectorAll('.shopify-section').forEach((section) => {
    if (section.querySelector('.gradient-hero-section')) {
      new GradientHeroSection(section);
    }
});
